export default __webpack_public_path__ + "static/media/sound.92372c5c.png";